// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "-legacy." + {"131":"cc709371","194":"dce4fe88","260":"daaf2031","440":"bff2b8a2","509":"7d18938e","581":"4f2dd301","668":"ff7e5b36","762":"bb300264","811":"48d8aaef","902":"32a734fa","973":"b7af226e","983":"08d9eac7"}[chunkId] + ".js";
};